import { FoodTemperatureControl } from "@enos-monorepo/lib/types/FoodManagementTypes";
import axios from "axios";

import { withFoodControlPointInstance } from "./foodControlPointService";

/*
Inventory
*/

export const addFoodTemperatureControl =
  withFoodControlPointInstance<FoodTemperatureControl>();
export const updateFoodTemperatureControl = withFoodControlPointInstance(true);

export async function getFoodTemperatureControlByInstanceId(id: string) {
  return axios
    .get<FoodTemperatureControl>(
      "/FoodTemperatureControls/getfoodtemperaturecontrolbyinstanceid",
      { params: { id } },
    )
    .then((res) => res.data);
}
